import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class View extends PureComponent {
  render() {
    const { displays } = this.props;

    return (
      <table className="responsive">
        <thead>
          <tr>
            <th colSpan="2">日程情報</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>イベント名</th>
            <td><span>{displays.simple_event_name}</span></td>
          </tr>
          <tr>
            <th>日程</th>
            <td><span>{displays.simple_event_program_name}</span></td>
          </tr>
          <tr>
            <th>Life is Tech ! Schoolをどうやって知りましたか </th>
            <td><span>{displays.learned_reason}</span></td>
          </tr>
        </tbody>
      </table>
    );
  }
}

View.propTypes = {
  displays: PropTypes.shape({
    simple_event_program_name: PropTypes.string,
  }).isRequired,
};

export default View;
